import { render, staticRenderFns } from "./LgsCotizationDetailImport.vue?vue&type=template&id=5ee95b44&"
import script from "./LgsCotizationDetailImport.vue?vue&type=script&lang=js&"
export * from "./LgsCotizationDetailImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports